import { TcAnnouncementBar } from '@tc-packages/tc-common'
import PropTypes from 'prop-types'
import React from 'react'

const TCAnnouncementBarWrapper = ({ announcementContent }) => {
  return (
    <div className="review-pagination">
      <TcAnnouncementBar announcementContent={announcementContent} />
    </div>
  )
}

TCAnnouncementBarWrapper.propTypes = {
  announcementContent: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  }),
}

export default TCAnnouncementBarWrapper
